<template>
  <div>
    <button type="button" class="link" @click="open || toggleOpen()">
      {{ callId }}
    </button>
    <call-details-modal
      v-if="open"
      :call-id="callId"
      :playable="playable"
      @hide-modal="toggleOpen"
    ></call-details-modal>
  </div>
</template>

<script>
import CallDetailsModal from "@/CallComponents/CallDetailsModal.vue";
export default {
  components: {
    CallDetailsModal,
  },
  props: {
    callId: {
      type: Number,
      default: null,
    },
    playable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped></style>
